import { useState, useEffect, useCallback } from 'react';
import { getDayTabLabels } from '@/mocks/generationForecast';

/**
 * Спільний стан шапки /forecast (редизайн): обрана доба + тригер експорту.
 * Керується з топбара (винесені вкладки дат / ◀дата▶ / Експорт), читається тілом
 * сторінки. Той самий прийом, що useForecastMmsDate / useFinancialResultUi.
 */
const EV = 'helios:forecast-ui-change';

export function forecastToday(): string {
  const tabs = getDayTabLabels();
  return tabs.find((d) => d.label === 'Today')?.apiDate ?? tabs[2]?.apiDate ?? new Date().toISOString().slice(0, 10);
}

export function shiftDayIso(iso: string, delta: number): string {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + delta);
  return `${dt.getUTCFullYear()}-${String(dt.getUTCMonth() + 1).padStart(2, '0')}-${String(dt.getUTCDate()).padStart(2, '0')}`;
}

const state = { date: forecastToday(), exportNonce: 0 };
const emit = () => window.dispatchEvent(new CustomEvent(EV));

export function useForecastUi() {
  const [, force] = useState(0);
  useEffect(() => {
    const refresh = () => force((x) => x + 1);
    window.addEventListener(EV, refresh);
    return () => window.removeEventListener(EV, refresh);
  }, []);
  const setDate = useCallback((d: string) => { state.date = d; emit(); }, []);
  const requestExport = useCallback(() => { state.exportNonce += 1; emit(); }, []);
  return { date: state.date, exportNonce: state.exportNonce, setDate, requestExport };
}
